import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_facility_taken_legally_required_steps_enable_workers_3'

export const dataPointDefinition = {
  retracedId: 'has_facility_taken_legally_required_steps_enable_workers_3',
  name: 'Has the facility taken legally required steps to enable workers who become disabled (for whatever reason) to retain thei',
  description: '',
  meta: {
    slcpMeta: {
      key: 'wt-dis-49',
      number: 'WT-DIS-19',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'yes-no-nalr',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],disc-9--2,>0',
      machineShowHide: '[1],disc-9--2,[>0]',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'yes_no_nalr',
      name: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['yes_no_nalr'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-49', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37400,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
